// extracted by mini-css-extract-plugin
module.exports = {"goBack":"SignUp-Confirm_goBack_Lf9rw","col":"SignUp-Confirm_col_3yaKw","center":"SignUp-Confirm_center_AXCZZ"};